<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBDialogColorPicker
			:dialog="dialog" 
			@update="onClickUpdate"
			@cancel="onClickCancel"
		/>
		<GBModalVScrollable class="color-select"
			title="色選択"
			header_height="115"
			v-bind:bottom_height="bottomHeight"
			v-bind:bottom_value="edit_color"
			v-on:close="onClose"
			v-on:click-modal-content="onCloseBottom"
		>
			<template v-slot:header>
				<div class="modal-header-color-select">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClose">取消</v-btn>
				</div>
			</template>
			<template v-if="display">
				<div class="color-item-group">
					<div class="color-title">基本色</div>
					<GBColorSelectItem 
						v-bind:value="value"
						v-bind:master_colors="master_colors"
						v-bind:item="defaultColor"
						v-bind:isSingleSelect="isSingleSelect"
						v-on:color-edit="onClickEdit"
						v-on:color-select="onClickSelect"
					/>
				</div>
				<div class="color-item-group" style="border-top: solid 1px #808080;">
					<div class="color-title mt-3">その他の色</div>
					<div class="new-add" v-if="$store.getters.isEditable && isSingleSelect">
						<v-btn flat large color="blue" v-on:click="onClickNewColor" v-bind:class="addBtnDisabled" :disabled="!canAddNewColor">
							<v-icon>add</v-icon>
							色を新規登録する
						</v-btn>
					</div>
					<GBColorSelectItem 
						v-for="c in otherColors"
						v-bind:key="c.code"
						v-bind:value="value"
						v-bind:master_colors="master_colors"
						v-bind:item="c"
						v-bind:isSingleSelect="isSingleSelect"
						v-on:color-edit="onClickEdit"
						v-on:color-select="onClickSelect"
					/>
				</div>
			</template>
			<template v-slot:bottom>
				<div class="edit">
					<v-btn fab flat absolute class="pa-0 ma-0 btn-edit-close"
						v-on:click="onCloseBottom"
					>
						<v-icon>close</v-icon>
					</v-btn>
					<v-layout row>
						<v-flex v-bind:class="classGrid">
							<v-text-field
								v-model="master_colors[target_index].name"
								maxlength="15"
								:rules="[rules.required, rules.length, rules.duplicate]"
								label="色"
								counter
								class="edit-input"
								ref="edit_input_color"
							></v-text-field>
						</v-flex>
						<v-flex xs2 align-self-end v-if="!isDefaultColor">
							<v-btn fab flat class="pa-0 ma-0"
								v-on:click="onClickShowDialogColorPicker"
							>
								<v-icon v-bind:style="styleEditColor">color_lens</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<div class="error-text" v-show="error_message">
						{{ error_message }}
					</div>
					<div class="btn-color-delete" v-if="!isDefaultColor">
						<v-btn flat class="mt-2"
							v-on:click="onClickColorDelete"
						>
							削除
						</v-btn>
					</div>
				</div>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBDialogColorPicker from './GBDialogColorPicker';
import GBColorSelectItem from './GBColorSelectItem';

import clonedeep from 'lodash/cloneDeep';
import { PERMISSION, COLOR_SELECT_TYPE } from '../data/Const';
import Color from '../data/Color';

const uuidv4 = require('uuid/v4');

const findTargetIndex = (colors, code) => {
	if (colors)
		return colors.findIndex(clr => clr.code === code);
	return null;
};

const validateDuplicate = (colors, name) => {
	let duplicate = colors.filter(clr => clr.name === name);
	if (duplicate.length > 1)
		return true;
	else
		return false;
};

const createEmptyColor = (type) => {
	return {
		code: uuidv4(),
		name: '新しい色',
		type: type,
		red: 0,
		green: 0,
		blue: 0,
		alpha: 1,
		default_value: 0,
		is_updated: 1,
		is_new: 1,
	};
}

const BOTTOM_HEIGHT = 170;

export default {
	name: 'GBRightPaneColorSelect',
	props: [
		"value",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBDialogColorPicker,
		GBColorSelectItem,
	},
	data: function() {
		return {
			edit_color: false,
			rules: {
				required: v => !!v || '入力してください',
				length: v => (v || '').length <= 20,
				duplicate: v => !validateDuplicate(this.master_colors, v) || '重複しています',
			},
			target_index: null,
			master_colors: null,
			error_message: '',
			dialog: {
				display: false,
				colors: {
					hex: '#000000',
					a: 1,
				},
				update: null,
				cancel: null,
			},
		};
	},
	methods: {
		closeBottom: function() {
			this.error_message = '';
			this.edit_color = false;
			this.target_index = null;
		},
		openBottom: function(index) {
			this.error_message = '';
			this.edit_color = true;
			this.target_index = index;
		},
		onClose: function() {
			this.edit_color = false;
			this.target_index = null;
			this.error_message = '';
			this.$emit('close');
		},
		onCloseBottom: function(e) {
			e.stopPropagation();
			if (e.target.closest('.color-item'))
				return ;
			
			if (this.target_index === null)
				return ;
				
			if (!this.confirmError())
				return ;
			this.closeBottom();
		},
		onClickNewColor: function(e) {
			e.stopPropagation();
			this.master_colors.push(createEmptyColor(this.value.type));
			this.openBottom(this.master_colors.length - 1);
			this.focusElement();
		},
		onClickEdit: function(e) {
			if (!this.confirmError())
				return ;
	
			this.openBottom(findTargetIndex(this.master_colors, e));
			this.focusElement();
		},
		onClickColorDelete: function(e) {
			e.stopPropagation();
			let index = findTargetIndex(this.value.selected, this.master_colors[this.target_index].code);
			if (index !== -1)
				this.value.selected.splice(index, 1);
			this.master_colors.splice(this.target_index, 1);
			this.closeBottom();
		},
		onClickSelect: function(e) {
			if (!this.confirmError())
				return ;
				
			this.error_message = '';
			this.target_index = findTargetIndex(this.master_colors, e);
			let target_color = this.master_colors[this.target_index];
			if (this.isSingleSelect) {
				this.value.selected = [{
					code: target_color.code,
				}];
			} else {
				let idx = findTargetIndex(this.value.selected, target_color.code);
				if (idx === -1 || idx === null) {
					this.value.selected.push({
						code: target_color.code,
					});
				}else{
					this.value.selected.splice(idx, 1);
				}
			}
			this.focusElement();
		},
		onClickDone: function() {
			if (!this.confirmError())
				return ;
				
			this.$emit('color-selected', this.value.selected);
			if (this.validateSyncMasterClass()) {
				this.$store.dispatch('setMasterColors', this.master_colors).then(() => {
					this.$emit('update-dataset');
				});
			}
			this.onClose();
		},
		validateMasterClass: function() {
			if (!this.edit_color)
				return true;
			if (!this.master_colors[this.target_index].name || validateDuplicate(this.master_colors, this.master_colors[this.target_index].name))
				return false;
			return true;
		},
		confirmError: function() {
			if (!this.validateMasterClass()) {
				if (!this.error_message) {
					this.error_message = 'すでに登録されているか、未入力です'
				}
				return false;
			}
			return true;
		},
		focusElement: function() {
			if (this.edit_color){
				this.$nextTick(() => {
					setTimeout(() => {
						let elem = this.$parent.$parent.$parent.$el.querySelector('.color-select .edit-input input');
						if (this.master_colors[this.target_index].is_new) {
							elem.select();
							this.master_colors[this.target_index].is_new = 0;
						}
					}, 10);
				});
			}
		},
		validateSyncMasterClass: function() {
			let validate = false;
			let copy_master_colors = clonedeep(this.$store.getters.masterColor).filter(c => c.type ===this.value.type);
			
			if (this.master_colors.length < copy_master_colors.length)
				validate = true;
			
			this.master_colors.forEach(clr => {
				let index = copy_master_colors.findIndex(c => 
					c.code === clr.code 
					&& c.name === clr.name 
					&& c.red === clr.red 
					&& c.green === clr.green 
					&& c.blue === clr.blue
				);
				if (index === -1) {
					clr.is_updated = 1;
					validate = true;
				}
			});
				
			return validate;
		},
		onClickShowDialogColorPicker: function() {
			const update = (rgba) => {
				let color = this.master_colors[this.target_index];
				color.red = rgba.r;
				color.green = rgba.g;
				color.blue = rgba.b;
				this.dialog.display = false;
			};
		
			let color = clonedeep(this.master_colors[this.target_index]);
			this.dialog.colors.hex = this.createColor(color.code).asHex;
			this.dialog.cancel = () => {
				this.dialog.display = false;
			};
			this.dialog.update = update;
			this.dialog.display = true;
		},
		onClickUpdate: function(rgba) {
			if (this.dialog.update)
				this.dialog.update(rgba);
			return;
		},
		onClickCancel: function() {
			if (this.dialog.cancel)
				this.dialog.cancel();
			return;
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		canAddNewColor: function() {
			return this.validateMasterClass() && this.hasAdmin;
		},
		addBtnDisabled: function() {
			if (!this.canAddNewColor)
				return ['disabled', 'add-btn-disabled'];
			return false;
		},
		bottomHeight: function() {
			if (this.edit_color)
				return BOTTOM_HEIGHT;
			return 0;
		},
		hasAdmin: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return false;
			
			return (access_token.pms & PERMISSION.TYPE.ADMIN) > 0;
		},
		isSingleSelect: function() {
			return this.value.select_type === COLOR_SELECT_TYPE.SINGLE;
		},
		createColor: function() {
			return function(code) {
				let color = this.master_colors.find(c => c.code === code);
				return new Color(Object.assign(Object.assign({}, color)))
			};
		},
		styleEditColor: function() {
			return {
				'color': this.createColor(this.master_colors[this.target_index].code).asHex,
			};
		},
		defaultColor: function() {
			return this.master_colors.find(c => c.type === this.value.type && c.default_value);
		},
		otherColors: function() {
			return this.master_colors.filter(c => !c.default_value);
		},
		isDefaultColor: function() {
			return this.createColor(this.master_colors[this.target_index].code).isDefaultColor;
		},
		isExistMasterColor: function() {
			return function(code) {
				let color = this.master_colors.find(c => c.code === code);
				if (color === undefined)
					return false;
				return true;
			}
		},
		classGrid: function() {
			if(this.isDefaultColor){
				return "xs12";
			}
			return "xs10";
		},
	},
	watch: {
		value: function(value) {
			if (value === null)
				this.master_colors = null;
			else
				this.master_colors = value.master_colors.filter(c => c.type === value.type);
		},
		'value.selected': function() {
			if (this.value) {
				if (this.isSingleSelect) {
					if (this.value.selected.length == 0) {
						this.value.selected.push({ code: this.defaultColor.code });
					} else {
						if (!this.isExistMasterColor(this.value.selected[0].code)) {
							this.value.selected = [{ code: this.defaultColor.code }];
						}
					}
				}
			}
		},
	},
}
</script>
<style>
	.modal-window.color-select .new-add {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}
	.modal-window.color-select .modal-header-color-select {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.color-select .color-item-group {
		margin: 10px;
	}
	.modal-window.color-select .color-item-wrapper {
		padding: 2px;
		margin: 2px;
	}
	.modal-window.color-select .color-item-wrapper.active {
		border-radius: 30px;
		background-color: #89c3eb;
	}
	.modal-window.color-select .color-item {
		position: relative;
		border-radius: 20px;
		font-size: 15px;
		height: 40px;
		margin: 5px;
		color: white;
	}
	.modal-window.color-select .color-item-name {
		display: flex;
		align-items: center;
		position: relative;
		top: -1px;
		left: -1px;
		border-radius: 20px 0px 0px 20px;
		height: 40px;
		padding: 0px 10px;
		cursor: pointer;
		user-select: none;
	}
	.modal-window.color-select .color-item-btn {
		position: absolute;
		border-radius: 0px 20px 20px 0px;
		top: -1px;
		right: -1px;
		height: 40px;
		width: 40px;
		margin: 0px;
		color: white;
	}
	.modal-window.color-select .color-item-active {
		color: white;
	}
	.modal-window.color-select .edit {
		margin: 10px 18px 10px 10px;
	}
	.modal-window.color-select .btn-edit-close {
		top: 0px;
		right: 8px;
		width: 30px;
		height: 30px;
	}
	.modal-window.color-select .edit-input {
		padding: 40px 10px 0px 10px;
		margin: 0px;
	}
	.modal-window.color-select .btn-color-delete {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.color-select .add-btn-disabled {
		color: #DFDFDF !important;
	}
	.modal-window.color-select .error-text {
		display: flex;
		justify-content: center;
		align-items: center;
		color: red;
	}
</style>
